import { FC } from 'react';
import { Box, Button, Typography } from '@material-ui/core';
import { useLocalization } from 'Hooks';
import { gutters } from 'Theme/Variables';
import { CreditCardListItem } from './CreditCardListItem';
import { DarkPlusIcon, MasterpassArea } from 'Components';
import { MasterpassCard } from 'Models';
import { useHistory } from 'react-router';
import { routePath } from 'Navigator/routes';

import './CreditCardList.scss';
import { useSelector } from 'react-redux';
import { creditCardTransactionsStore } from 'Stores/CreditCardTransactions';

type CreditCardListProps = {
  data: MasterpassCard[];
};

const CreditCardList: FC<CreditCardListProps> = ({ data }) => {
  const { web_title_registered_credit_cards, web_btn_add_credit_card } = useLocalization();
  const history = useHistory();
  const { creditCardBinList } = useSelector(creditCardTransactionsStore);

  return (
    <div id="credit-card-list">
      <Typography variant="h3" component="h1">
        <Box className="credit-card-list__title" marginBottom={gutters.large} fontWeight={600} textAlign="center">
          {web_title_registered_credit_cards}
        </Box>
      </Typography>
      <ul> 
        {data.map((item) => (
            <li 
            key={item.cardAlias}
            role="button"
            tabIndex={0}
            onClick={() => history.push(routePath.creditCardDetail, item)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                history.push(routePath.creditCardDetail, item);
              }
            }}
            >
              <CreditCardListItem {...item} />
            </li>
        ))}
      </ul>

      <Button
        variant="outlined"
        color="secondary"
        fullWidth
        startIcon={<DarkPlusIcon />}
        onClick={() => history.push(routePath.addCreditCard)}
        type="submit"
        className="rootAbsolute"
        itemID="addCreditCardBtnTest"
      >
        {web_btn_add_credit_card}
      </Button>
      <MasterpassArea />
    </div>
  );
};

export default CreditCardList;
